<template>
  <div class="tile sm-12" :class="{'fullheight': fullheight}">
    <div class="header" v-if="$slots.title || $slots.subtitle">
      <div class="left">
        <div class="title">
          <slot name="title"></slot>
        </div>
        <div class="subtitle">
          <slot name="subtitle"></slot>
        </div>
      </div>
      <div class="right">
        <slot name="actions"></slot>
      </div>
    </div>

    <div class="content" v-if="$slots.content">
      <slot name="content"></slot>
    </div>

    <div class="bottom" v-if="$slots.bottom">
      <slot name="bottom"></slot>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    fullheight: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="less" scoped>
@import '~@/assets/common.less';
</style>